export function getUrlSegments(pathname: string): string[] {
  /** Remove leading and trailing slashes */
  const trimmedPathname = pathname.replace(/^\/|\/$/g, "");
  const segments = trimmedPathname.split("/");
  return segments;
}
